window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     // Rescue error
   }

  	// Newsletter 
    let consent = window.Shopify.customerPrivacy.getTrackingConsent();

   
	if ( consent == 'yes' ) {

        let popup =  document.querySelector('.marketing-popup-container');
        let	cookieName = 'popup_' + popup.dataset.slug;
        let popupCookie = localStorage.getItem(cookieName);
        let close =  document.querySelector('a.popup-close');
      
		if (!popupCookie) {
            // Show popup
            popup.classList.add('show-popup')
            lazyLoadInstance.update();
		}
        close.addEventListener("click", function(e) {

            // Hide popup
            popup.classList.remove('show-popup');

            // Set local storage to prevent being shown again
            localStorage.setItem(cookieName, 'closed');
        }, false);
	}
  },
);

  

